import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UnsubNotificationsComponent } from './unsub-notifications/unsub-notifications.component';
import { JSONHash } from 'angular-lib';


@Component({
    selector: 'ez-feedback',
    template: require('./feedback.component.html'),
    styles: [require('./feedback.component.less')]
})
export class FeedbackComponent implements OnInit {
    private componentReference: any;
    @ViewChild('template', {read: ViewContainerRef}) private template: ViewContainerRef;
    @Input() public type: string = '';
    public types: JSONHash = {
        'unsubMail': UnsubNotificationsComponent
    };
    public showClass: string = '';
    public classes: string = '';

    constructor(
        private resolver: ComponentFactoryResolver
    ) {
    }

    public ngOnInit() {
        let factory = this.resolver.resolveComponentFactory(this.types[this.type]);
        this.componentReference = this.template.createComponent(factory);
        this.classes = this.classes + ' ' + this.componentReference.instance.classes;
        this.componentReference.instance.data = {};
    }

    public toggle() {
        setTimeout(() => {
        this.showClass = this.showClass === 'scrollIn' ? 'scrollOut' : 'scrollIn';
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/feedback/feedback.component.ts